"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _7XPYSHN7cjs = require('../__chunks/7XPYSHN7.cjs');
require('../__chunks/F7D3HWZN.cjs');


var _EV33XSIBcjs = require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-separator.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "hr";
var useComboboxSeparator = _PTOCUU2Dcjs.createHook.call(void 0, function useComboboxSeparator2({ store, ...props }) {
  const context = _EV33XSIBcjs.useComboboxScopedContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "ComboboxSeparator must be wrapped in a ComboboxList or ComboboxPopover component."
  );
  props = _7XPYSHN7cjs.useCompositeSeparator.call(void 0, { store, ...props });
  return props;
});
var ComboboxSeparator = _PTOCUU2Dcjs.forwardRef.call(void 0, function ComboboxSeparator2(props) {
  const htmlProps = useComboboxSeparator(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.ComboboxSeparator = ComboboxSeparator; exports.useComboboxSeparator = useComboboxSeparator;
